"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Scroller = /** @class */ (function () {
    function Scroller() {
        this.lastTime = 0;
    }
    Scroller.prototype.init = function (context, callback) {
        var _this = this;
        this.$el = $(context);
        this.callback = callback;
        var vendors = ['ms', 'moz', 'webkit', 'o'];
        for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
            window.requestAnimationFrame = window[vendors[i] + 'RequestAnimationFrame'];
        }
        for (var i = 0; i < vendors.length && !window.cancelAnimationFrame; ++i) {
            window.cancelAnimationFrame = window[vendors[i] + 'CancelAnimationFrame']
                || window[vendors[i] + 'CancelRequestAnimationFrame'];
        }
        if (!window.requestAnimationFrame) {
            window.requestAnimationFrame = function (callback) {
                var currTime = new Date().getTime();
                var timeToCall = Math.max(0, 16 - (currTime - _this.lastTime));
                var id = window.setTimeout(function () { callback(currTime + timeToCall); }, timeToCall);
                _this.lastTime = currTime + timeToCall;
                return id;
            };
        }
        if (!window.cancelAnimationFrame) {
            window.cancelAnimationFrame = function (id) {
                clearTimeout(id);
            };
        }
        $.easing.easeOutCubic = function (x, t, b, c, d) {
            return c * ((t = t / d - 1) * t * t + 1) + b;
        };
        this.onScroll();
        $(window).on('scroll', function () {
            window.requestAnimationFrame(function () { _this.onScroll(); });
        });
    };
    Scroller.prototype.scrollTo = function (selector, duration) {
        var navMargin = parseInt($('.header-main').css('marginTop'), 10), navHeight = $('.header-main').outerHeight(), navOffset = navMargin + navHeight + 25, element = $(selector), target = element.offset().top - navOffset, current = $(window).scrollTop();
        if (duration === undefined) {
            duration = Math.min(1000, Math.abs(current - target));
        }
        if (Math.abs(current - target) > 100) {
            $('html, body').animate({ scrollTop: (target) }, {
                duration: duration,
                progress: this.onScroll,
                easing: 'easeOutCubic'
            });
        }
    };
    Scroller.prototype.onScroll = function () {
        // TODO: Handle sticky preview
        if (this.callback) {
            this.callback();
        }
    };
    return Scroller;
}());
exports.Scroller = Scroller;
exports.default = angular.module('pb.scroller', [])
    .service('scroller', Scroller);
